import {
  useState,
  useRef,
  useEffect,
  useCallback,
  Dispatch,
  RefObject,
  SetStateAction,
  MutableRefObject,
} from 'react';

interface ToggleDropdownParams {
  toggleDropdown: boolean;
  setToggleDropdown: Dispatch<SetStateAction<boolean>>;
  refDropdown: RefObject<HTMLElement>;
}

const useMouseCapture = (eventHandler: (evt: MouseEvent | TouchEvent) => void): void => {
  useEffect(() => {
    document.addEventListener('mousedown', eventHandler);
    document.addEventListener('touchstart', eventHandler);

    return (): void => {
      document.removeEventListener('mousedown', eventHandler);
      document.removeEventListener('touchstart', eventHandler);
    };
  }, [eventHandler]);
};

export const useToggleDropdown = (
  exceptionRef?: MutableRefObject<HTMLElement | undefined>
): ToggleDropdownParams => {
  const refDropdown = useRef<HTMLElement>(null);
  const [toggleDropdown, setToggleDropdown] = useState(false);

  const handleDropdown = useCallback(
    ({ target }: MouseEvent | TouchEvent): void => {
      if (
        refDropdown?.current?.contains(target as Node) ||
        (exceptionRef && exceptionRef.current?.contains(target as Node))
      )
        return;

      setToggleDropdown(false);
    },
    [exceptionRef]
  );

  useMouseCapture(handleDropdown);

  return { toggleDropdown, setToggleDropdown, refDropdown };
};

export default {};
